import type { QuickFact } from "@/lib/productContent";

export function QuickFactsTable({ facts }: { facts: QuickFact[] }) {
  return (
    <section aria-labelledby="quick-facts-heading" className="mt-8 md:mt-10">
      <div className="mx-auto max-w-3xl">
        <p className="text-[11px] font-semibold uppercase tracking-[0.22em] text-brand">
          Quick facts
        </p>
        <h2
          id="quick-facts-heading"
          className="mt-2 font-display text-2xl font-bold text-brand-deep md:text-3xl"
        >
          The label, summarised
        </h2>
        <dl className="mt-6 divide-y divide-border overflow-hidden rounded-2xl border border-border bg-card">
          {facts.map((f) => (
            <div
              key={f.label}
              className="grid grid-cols-1 gap-1 px-5 py-4 md:grid-cols-[200px_1fr] md:gap-6"
            >
              <dt className="text-[11px] font-semibold uppercase tracking-wider text-muted-foreground md:text-xs">
                {f.label}
              </dt>
              <dd className="text-sm leading-relaxed text-brand-deep">{f.value}</dd>
            </div>
          ))}
        </dl>
      </div>
    </section>
  );
}
